/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    VersionResponse,
    VersionResponseFromJSON,
    VersionResponseToJSON,
} from '../models';

/**
 * 
 */
export class VersionApi extends runtime.BaseAPI {

    /**
     * Returns the current UI API version.
     */
    async getVersionRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<VersionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/version`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VersionResponseFromJSON(jsonValue));
    }

    /**
     * Returns the current UI API version.
     */
    async getVersion(initOverrides?: RequestInit): Promise<VersionResponse> {
        const response = await this.getVersionRaw(initOverrides);
        return await response.value();
    }

}
